export default "__VITE_ASSET__D7PytX8W__"